import __request__ from "routing/request";
export function list(inputId, requestOptions) {
  return __request__("GET", `/system/inputs/${inputId}/extractors`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(inputId, JSONbody, requestOptions) {
  return __request__("POST", `/system/inputs/${inputId}/extractors`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function order(inputId, JSONbody, requestOptions) {
  return __request__("POST", `/system/inputs/${inputId}/extractors/order`, JSONbody, {}, {
    "Accept": []
  }, requestOptions);
}
export function update(inputId, extractorId, JSONbody, requestOptions) {
  return __request__("PUT", `/system/inputs/${inputId}/extractors/${extractorId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function single(inputId, extractorId, requestOptions) {
  return __request__("GET", `/system/inputs/${inputId}/extractors/${extractorId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function terminate(inputId, extractorId, requestOptions) {
  return __request__("DELETE", `/system/inputs/${inputId}/extractors/${extractorId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
